export type Colors = typeof colors

const colors = {
  gray: {
    100: "#f7f7f7",
    300: "#d4d4d4",
    400: "#b0b0b0",
    500: "#646464",
    700: "#222222",
    900: "#141414",
  },
  blue: {
    100: "#e8e8ff",
    300: "#8d8dff",
    500: "#1c1cff",
    700: "#0b0b66",
  },
  orange: {
    100: "#ffe3d3",
    300: "#ffb991",
    500: "#ff7324",
    800: "#451900",
  },
  red: {
    100: "#F7C8C8",
    500: "#b80000",
    900: "#1B0C0C",
  },
  green: {
    100: "#C8F7D8",
    400: "#48BB78",
    500: "#109e62",
    900: "#0A160E",
  },
  yellow: {
    200: "#fff8df",
  },
}

export default colors
